import MyDatePicker2 from "./MyDatePicker2";

export default MyDatePicker2;
